import styled from 'styled-components'
import TextFieldMui from 'src/components/TextFieldMui'

export const Form = styled.div`
  width: fit-content;
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;
  align-items: center;
  justify-content: center;
  gap: 0.4rem;
  width: 500px;
  padding: 8px;
`

export const ButtonSection = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;
`

export const CustomFieldMui = styled(TextFieldMui)`
  margin-top: 8px !important;
`
